/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransferException } from './TransferException';
import {
    TransferExceptionFromJSON,
    TransferExceptionFromJSONTyped,
    TransferExceptionToJSON,
} from './TransferException';

/**
 * 
 * @export
 * @interface ListTransferExceptionsResponseBody
 */
export interface ListTransferExceptionsResponseBody {
    /**
     * 
     * @type {Array<TransferException>}
     * @memberof ListTransferExceptionsResponseBody
     */
    items: Array<TransferException>;
    /**
     * A cursor for use in the subsequent call.
     * @type {string}
     * @memberof ListTransferExceptionsResponseBody
     */
    startingAfter?: string;
    /**
     * The total number of items in the collection.
     * @type {number}
     * @memberof ListTransferExceptionsResponseBody
     */
    totalCount: number;
}

/**
 * Check if a given object implements the ListTransferExceptionsResponseBody interface.
 */
export function instanceOfListTransferExceptionsResponseBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "totalCount" in value;

    return isInstance;
}

export function ListTransferExceptionsResponseBodyFromJSON(json: any): ListTransferExceptionsResponseBody {
    return ListTransferExceptionsResponseBodyFromJSONTyped(json, false);
}

export function ListTransferExceptionsResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTransferExceptionsResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(TransferExceptionFromJSON)),
        'startingAfter': !exists(json, 'starting_after') ? undefined : json['starting_after'],
        'totalCount': json['total_count'],
    };
}

export function ListTransferExceptionsResponseBodyToJSON(value?: ListTransferExceptionsResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(TransferExceptionToJSON)),
        'starting_after': value.startingAfter,
        'total_count': value.totalCount,
    };
}

